import Typography from "typography"
import { COLORS } from "../styles/colors"

const typography = new Typography({
  baseFontSize: "18px",
  headerFontFamily: ["CustomFourBold", "sans-serif"],
  bodyFontFamily: ["CustomFour", "sans-serif"],
  overrideStyles: () => ({
    [`h1,h2,h3,h4,h5,h6`]: {
      fontWeight: 500,
      color: COLORS.MEDIUM_GREEN,
      letterSpacing: "0.19px",
    },
    a: {
      color: COLORS.RED,
      textDecoration: "none",
    },
    blockquote: {
      paddingLeft: "20px",
      borderLeft: `solid ${COLORS.MEDIUM_GREEN} 5px`,
    },
  }),
})

// Hot reload typography in development.
if (process.env.NODE_ENV !== `production`) {
  typography.injectStyles()
}

export default typography
export const rhythm = typography.rhythm
export const scale = typography.scale
